import { createFileRoute } from '@tanstack/react-router'
import ImportPrices from 'Imports/components/Prices/ImportPrices'

import { Guard, adminClaims } from '../-guard'

export const Route = createFileRoute('/imports/importprices')({
    component: () => (
        <Guard claims={adminClaims}>
            <ImportPrices />
        </Guard>
    ),
})
